import { render, staticRenderFns } from "./SecaoDuvidas.vue?vue&type=template&id=fa491b10&"
import script from "./SecaoDuvidas.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoDuvidas.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports